import { render, staticRenderFns } from "./EditStakeholder.vue?vue&type=template&id=7b8878db&scoped=true"
import script from "./EditStakeholder.vue?vue&type=script&lang=js"
export * from "./EditStakeholder.vue?vue&type=script&lang=js"
import style0 from "./EditStakeholder.vue?vue&type=style&index=0&id=7b8878db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8878db",
  null
  
)

export default component.exports